
























































import { Component, Vue, Prop } from "vue-property-decorator";

import { Zone } from "@/types";
import { className } from "@/utilities";

import BorderNavButton from "@/components/BorderNavButton.vue";
import ZoneBackground from "@/components/ZoneBackground.vue";

@Component({
  components: { BorderNavButton, ZoneBackground },
})
export default class ZoneView extends Vue {
  get zone(): Zone {
    const name = this.$route.params.zone;
    return this.$store.state.garden.zones[name];
  }

  get borders() {
    return this.zone.borders;
  }

  get zoneClassName() {
    return className(this.zone!.alias!);
  }
}
